import { useTranslation } from 'react-i18next';
import { useState, Dispatch, SetStateAction } from 'react';
import logo from 'shared/assets/Xplir_logo_rgb.svg';
import LazyTippy from 'shared/overlays/LazyTippy';

interface ModalContentProps {
  setToggleSupportModal: Dispatch<SetStateAction<boolean>>;
  toggleSupportModal: boolean;
}

const ModalContent = ({ setToggleSupportModal, toggleSupportModal }: ModalContentProps) => {
  const { t } = useTranslation('support');

  return (
    <div className="card support-modal">
      <div className="card-header columns col-auto-1fr-auto p-3">
        <img src={logo} alt="logo" className="rounded-circle p-1 support-modal-header-img" />
        <p className="fw-bold">{t('modal.header-title')}</p>
        <i className="fa-regular fa-square-minus" onClick={() => setToggleSupportModal(!toggleSupportModal)} />
      </div>
      <div className="card-body p-3">
        <div className="columns col-auto-1fr-auto support-modal-helpdesk p-3">
          <i className="fa-regular fa-book-open-reader rounded-circle p-3" />
          <div>
            <h3>{t('modal.helpdesk-title')}</h3>
            <p>{t('modal.helpdesk-text')}</p>
          </div>
          <a href={t('modal.link')} target="_blank" rel="noopener noreferrer" className="align-self-center">
            <i className="fa-regular fa-arrow-right" />
          </a>
        </div>
        <div className="text-center mt-4">
          <p className="mb-2">{t('modal.contact-title')}</p>
          <a href="mailto:support@xplir.com" className="text-uppercase fw-bold support-modal-contact-link">
            {t('modal.contact-text')}
          </a>
        </div>
      </div>
    </div>
  );
};

interface SupportModalProps {
  bottomOffset?: number;
}

const SupportModal = ({ bottomOffset: _bottomOffset }: SupportModalProps) => {
  const [toggleSupportModal, setToggleSupportModal] = useState(false);

  const handleSupportClick = () => {
    setToggleSupportModal(!toggleSupportModal);
  };

  return (
    <LazyTippy
      visible={toggleSupportModal}
      onClickOutside={() => setToggleSupportModal(!toggleSupportModal)}
      content={<ModalContent toggleSupportModal={toggleSupportModal} setToggleSupportModal={setToggleSupportModal} />}
      offset={[-210, 5]}
      interactive={true}
      onTrigger={() => setToggleSupportModal(!toggleSupportModal)}
    >
      <div className="support-button aspect-1x1 rounded-circle" onClick={() => handleSupportClick()}>
        <i className="fa-regular fa-circle-question"></i>
      </div>
    </LazyTippy>
  );
};

export default SupportModal;
